export default __webpack_public_path__ + "static/media/01_LongChen.ed9592f6.png";